import { ap as apR, curryN, pathSatisfies, both, either } from 'ramda';

import isFunction from '../isFunction';
import fl from '../fantasy-land/mapping';

var isFunctor = /*#__PURE__*/either( /*#__PURE__*/pathSatisfies(isFunction, ['map']), /*#__PURE__*/pathSatisfies(isFunction, [fl.map]));
var isApply = /*#__PURE__*/both(isFunctor, /*#__PURE__*/either( /*#__PURE__*/pathSatisfies(isFunction, ['ap']), /*#__PURE__*/pathSatisfies(isFunction, [fl.ap])));

var ap = /*#__PURE__*/curryN(2, function (applyF, applyX) {
  // return original ramda `ap` if not Apply spec
  if (!isApply(applyF) || !isApply(applyX)) {
    return apR(applyF, applyX);
  }

  try {
    // new version of `ap` starting from ramda version > 0.23.0
    return applyF.ap(applyX);
  } catch (e) {
    // old version of `ap` till ramda version <= 0.23.0
    return applyX.ap(applyF);
  }
});

export default ap;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda-adjunct/es/internal/ap.js
// module id = 763
// module chunks = 0